function RegisteredTravelAgent() {
    return (
      <>
        <div className="font-bold text-lg mb-16">RegisteredTravelAgentCustomField</div>
      </>
    );
  }
  
  export default RegisteredTravelAgent;